import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureDemo = ({ features }) => {
  if (!features || features?.length === 0) return null;

  return (
    <div className="feature-demo mt-8">
      <h4 className="text-h4 font-heading text-gray-900 mb-4">Key Features</h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {features?.map((feature, index) => (
          <div
            key={index}
            className="bg-white border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 hover:shadow-warm-md transition-all"
          >
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                <Icon name="calendar-heart" size={16} className="text-blue-600" />
              </div>
              <h5 className="text-h5 font-heading text-gray-900">{feature?.label}</h5>
            </div>
            <p className="text-sm text-gray-600">{feature?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureDemo;